<template>
  <div>
    <el-card>
      <el-table
        v-if="isDesktop"
        v-loading="loading"
        :data="items"
        size="small"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="Date"
          :formatter="formatter"
          prop="created_at"
        />
        <el-table-column
          align="center"
          label="Type"
          prop="type"
          fit
          min-width="85"
        >
          <template #default="{ row }">
            <TypeLabel :type="row.attributes.type_id" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="Replenishment" prop="amount">
          <template #default="{ row }"> ${{ row.attributes.amount }} </template>
        </el-table-column>
        <el-table-column align="center" label="Fee" prop="commission">
          <template #default="{ row }">
            ${{ row.attributes.commission }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="TAX" prop="vat">
          <template #default="{ row }"> ${{ row.attributes.vat }} </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="Total amount"
          prop="total_amount"
        >
          <template #default="{ row }">
            ${{ row.attributes.total_amount }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="Comment"
          :formatter="formatter"
          prop="comment"
        />
        <el-table-column
          align="center"
          label="Payment system"
          :formatter="formatter"
          prop="payment_account"
        />
        <el-table-column v-if="withInvoice" align="center" label="Invoice">
          <template #default="{ row }">
            <el-link
              v-if="row.attributes.link"
              type="primary"
              target="_blank"
              :href="row.attributes.link"
            >
              Download invoice
              <el-icon class="el-icon--right">
                <DownloadElementIcon />
              </el-icon>
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-else :data="items" style="width: 100%">
        <el-table-column type="expand">
          <template #default="props">
            <p>Date: {{ props.row.attributes.created_at }}</p>
            <p>Replenishment: ${{ props.row.attributes.amount }}</p>
            <p>Fee: ${{ props.row.attributes.commission }}</p>
            <p>TAX: ${{ props.row.attributes.vat }}</p>
            <p>Total amount: ${{ props.row.attributes.total_amount }}</p>
            <p>Comment: {{ props.row.attributes.comment }}</p>
            <p>Payment system: {{ props.row.attributes.payment_account }}</p>
            <p>
              Type:
              <TypeLabel :type="props.row.attributes.type_id" />
            </p>

            <el-link
              v-if="props.row.attributes.link"
              type="primary"
              target="_blank"
              :href="props.row.attributes.link"
            >
              Download invoice
              <el-icon class="el-icon--right">
                <DownloadElementIcon />
              </el-icon>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="Date"
          :formatter="formatter"
          prop="created_at"
        >
          <template #default="{ row }">
            {{ row.attributes.created_at }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="Replenishment" prop="amount">
          <template #default="{ row }"> ${{ row.attributes.amount }} </template>
        </el-table-column>
      </el-table>
    </el-card>
    <Pagination
      v-if="total > 0"
      :total="total"
      :page="page"
      @pagination="applyPagination"
    />
  </div>
</template>
<script lang="ts">
import { computed, ref, defineComponent } from 'vue'
import Pagination from '@/components/Pagination.vue'
import useResize from '@/hooks/useResize'
import TypeLabel from './TypeLabel.vue'

export default defineComponent({
  name: 'TransactionsTable',
  components: {
    TypeLabel,
    Pagination
  },
  props: {
    total: {
      type: Number,
      required: true
    },
    type: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    withInvoice: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const loading = ref(false)
    const { isDesktop } = useResize()
    const page = ref(1)
    const formatter = (row: any, col: any) => {
      const prop = String(col.property)
      return row.attributes[prop]
    }

    const applyPagination = (options: any) => {
      page.value = options.newPage
      context.emit('update', { typeId: props.type, ...options })
    }
    return {
      applyPagination,
      formatter,
      loading,
      isDesktop,
      page
    }
  }
})
</script>

<style lang="scss">
.el-table .cell {
  word-break: break-word;
}

.payment-page-header {
  display: flex;
  justify-content: space-between;
}
</style>
